import api from "../apiConfig";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  getAll(data) {
    let params = "";
    if (data) {
      Object.keys(data).forEach((key) => {
        if (data[key] !== null && data[key] !== undefined && data[key] !== "") {
          params += `${key}=${data[key]}&`;
        }
      });
    }
    return api.get(`/api/v1/offer?${params}`);
  },
  getById(id) {
    return api.get(`/api/v1/offer/${id}`);
  },
  toggleStatus(id) {
    return api.put(`/api/v1/offer/toggle-status/${id}`);
  },
  create(data) {
    return api.post(`/api/v1/offer`, data);
  },
  delete(id) {
    return api.delete(`/api/v1/offer/${id}`);
  },
};
